"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var contexts_1 = require("../../contexts");
var logger_1 = __importDefault(require("../../helpers/logger"));
var hooks_1 = require("../../hooks");
var CrudEdit = function (props) {
    var getItem = props.getItem, onUpdate = props.onUpdate, selectedItem = props.selectedItem, children = props.children;
    var _a = react_1.useState(), currentItem = _a[0], setCurrentItem = _a[1];
    var params = hooks_1.useRouter().match.params;
    react_1.useEffect(function () {
        var loadItem = function () { return __awaiter(_this, void 0, void 0, function () {
            var resp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, (getItem ? getItem(selectedItem || params) : Promise.resolve(selectedItem))];
                    case 1:
                        resp = _a.sent();
                        setCurrentItem(resp);
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        logger_1.default.error(err_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        loadItem();
    }, [getItem, selectedItem, params]);
    var crudState = react_1.useMemo(function () { return ({
        selectedItem: currentItem,
        isCreate: false,
        isUpdate: true,
    }); }, [currentItem]);
    var childrenWithProps = react_1.useMemo(function () {
        return react_1.default.Children.map(children, function (child) {
            return react_1.default.cloneElement(child, {
                initialValues: currentItem,
                onSubmit: onUpdate,
            });
        });
    }, [children, currentItem, onUpdate]);
    return (react_1.default.createElement(contexts_1.CrudContext.Provider, { value: crudState },
        react_1.default.createElement(antd_1.Card, { className: "ant-app-details-area" }, childrenWithProps)));
};
exports.default = CrudEdit;
